import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";  // Import getAuth for authentication
import { getFirestore } from "firebase/firestore";  // Import Firestore for db
import { getStorage } from "firebase/storage";  // Optional, if you're using storage

const firebaseConfig = {
  apiKey: "AIzaSyBkuYWP22Si8bV8wrVkF1a3929bry0kIsA",
  authDomain: "southern-rehab-care.firebaseapp.com",
  projectId: "southern-rehab-care",
  storageBucket: "southern-rehab-care.firebasestorage.app",
  messagingSenderId: "1409583291",
  appId: "1:1409583291:web:f163d36d943bb97483c19e"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);  // Initialize Firebase Authentication
const db = getFirestore(app);  // Initialize Firestore
const storage = getStorage(app);  // Initialize Firebase Storage (if needed)

export { auth, db, storage };